export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.f3291b590067f441efc173000f7e56ca.css";